// @flow
import { connect } from 'react-redux';
import App from '../components/App';

const mapStateToProps = ({ authReducer }, ownProps) => ({
  session: authReducer.session,
  brand: ownProps.brand,
  theme: ownProps.theme
});

const AppContainer = connect(mapStateToProps, {})(App);
export default AppContainer;
